"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Announcer = Announcer;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grommet = require("grommet");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AnnouncerComponent(_ref) {
  var announce = _ref.announce,
    message = _ref.message,
    mode = _ref.mode,
    role = _ref.role;
  announce(message, mode);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Text, {
    role: role,
    "aria-live": mode,
    children: message
  });
}
AnnouncerComponent.propTypes = {
  announce: _propTypes["default"].func.isRequired,
  message: _propTypes["default"].string.isRequired,
  mode: _propTypes["default"].string.isRequired,
  role: _propTypes["default"].string.isRequired
};
function Announcer(_ref2) {
  var message = _ref2.message,
    _ref2$mode = _ref2.mode,
    mode = _ref2$mode === void 0 ? 'assertive' : _ref2$mode,
    _ref2$role = _ref2.role,
    role = _ref2$role === void 0 ? 'alert' : _ref2$role;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.AnnounceContext.Consumer, {
    children: function children(announce) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AnnouncerComponent, {
        announce: announce,
        mode: mode,
        role: role,
        message: message
      });
    }
  });
}
Announcer.propTypes = {
  message: _propTypes["default"].string.isRequired,
  mode: _propTypes["default"].string,
  role: _propTypes["default"].string
};